interface ProgressDotsProps {
  total: number;
  current: number; // 1-indexed
}

export function ProgressDots({ total, current }: ProgressDotsProps) {
  return (
    <div
      class="flex items-center justify-center gap-2"
      role="progressbar"
      aria-valuenow={current}
      aria-valuemin={1}
      aria-valuemax={total}
      aria-label={`Step ${current} of ${total}`}
    >
      {Array.from({ length: total }, (_, i) => (
        <span
          key={i}
          class={`w-2 h-2 rounded-full transition-colors ${
            i + 1 === current
              ? 'bg-hudson-navy'
              : i + 1 < current
              ? 'bg-grain-gold'
              : 'bg-card-border'
          }`}
          aria-hidden="true"
        />
      ))}
    </div>
  );
}
